import * as React from "react";
import { DateTime } from "luxon";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as productionMethodIconSetFragments } from "../../ProductionMethodIconSet/graph";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ProductionMethodIconSet from "../../ProductionMethodIconSet";

import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  divider: {
    marginTop: theme.spacing(1)
  },

  listItemContainer: {
    width: "100%"
  },

  listItem: {
    paddingBottom: 0
  },

  spaceBetweenWrapper: {
    display: "flex",
    justifyContent: "space-between"
  }
}));

const SidebarListItem = ({
  onListItemSelected,
  order,
  order: {
    orderNumber,
    primaryCustomer: { name_sidebarListItemCustomerName },
    productionDate
  },
  index
}) => {
  const classes = useStyles();

  return (
    <ListItem
      className={classes.listItem}
      onClick={() => onListItemSelected(index)}
      button
    >
      <div className={classes.listItemContainer}>
        <div className={classes.spaceBetweenWrapper}>
          <Typography variant="body1">
            {name_sidebarListItemCustomerName}
          </Typography>
          {productionDate && (
            <Typography color="textSecondary" variant="caption">
              {DateTime.fromISO(productionDate).toLocaleString(
                DateTime.DATE_SHORT
              )}
            </Typography>
          )}
        </div>
        <div className={classes.spaceBetweenWrapper}>
          <Typography variant="body1">{orderNumber}</Typography>
          <div>
            <ProductionMethodIconSet
              productionMethodStatuses={filter(
                productionMethodIconSetFragments.order,
                order
              )}
            />
          </div>
        </div>
        <Divider light={true} className={classes.divider} />
      </div>
    </ListItem>
  );
};

export default SidebarListItem;
